(function(){
  var kp=document.getElementById('kp'),b=document.getElementById('tgl'),ic=document.getElementById('tgl-i');
  var moon='<path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z"/>';
  var sun='<circle cx="12" cy="12" r="4.2"/><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"/>';
  function icon(m){if(ic)ic.innerHTML=(m==='light'?moon:sun);}
  function apply(m){kp.setAttribute('data-mode',m);icon(m);}
  icon(kp.getAttribute('data-mode')||'light');
  if(b)b.addEventListener('click',function(){
    var next=(kp.getAttribute('data-mode')==='dark')?'light':'dark';
    kp.classList.add('theme-anim');
    apply(next);
    try{localStorage.setItem('kp-mode',next);}catch(e){}
    setTimeout(function(){kp.classList.remove('theme-anim');},260);
  });
  var mb=document.getElementById('mtgl'),mm=document.getElementById('mmenu');
  if(mb&&mm){
    mb.addEventListener('click',function(){var o=mm.classList.toggle('open');mb.setAttribute('aria-expanded',o?'true':'false');});
    mm.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mm.classList.remove('open');mb.setAttribute('aria-expanded','false');});});
  }
})();
